var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddimagewhitetheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#bfbfbf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25.5L10.3641 17.9494C10.7754 17.4615 11.5323 17.4784 11.9214 17.9842L16.7735 24.2923C17.108 24.7272 17.7305 24.8113 18.1685 24.4808L21.1229 22.2513C21.4737 21.9866 21.9563 21.9819 22.3121 22.2399L27.5 26",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15C26 16.6569 24.6569 18 23 18C21.3431 18 20 16.6569 20 15C20 13.3431 21.3431 12 23 12C24.6569 12 26 13.3431 26 15Z",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimagewhitetheme);
export default __webpack_public_path__ + "static/media/addimagewhitetheme.879fdb0a.svg";
export { ForwardRef as ReactComponent };var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddimagewhitetheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#bfbfbf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25.5L10.3641 17.9494C10.7754 17.4615 11.5323 17.4784 11.9214 17.9842L16.7735 24.2923C17.108 24.7272 17.7305 24.8113 18.1685 24.4808L21.1229 22.2513C21.4737 21.9866 21.9563 21.9819 22.3121 22.2399L27.5 26",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 15C26 16.6569 24.6569 18 23 18C21.3431 18 20 16.6569 20 15C20 13.3431 21.3431 12 23 12C24.6569 12 26 13.3431 26 15Z",
    stroke: "#bfbfbf",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimagewhitetheme);
export default __webpack_public_path__ + "static/media/addimagewhitetheme.879fdb0a.svg";
export { ForwardRef as ReactComponent };